import { FloatingLabelDateInputLayout } from 'framework/ui/layout';
import { DATE_FORMAT, useDateService } from 'framework/utils/hooks/useDateService';
import type { FillInputProps } from '../fillInput';

export const DatepickerInput = (props: FillInputProps<string | null, object>) => {
  const { inputId, label, showLabel, value, onChange, onBlur, disabled, required, error, bounds } = props;
  const { formatDateForAPI, getUserTimezone, isIsoDate } = useDateService();

  return (
    <FloatingLabelDateInputLayout
      source={inputId}
      label={showLabel ? label : undefined}
      value={value ?? ''}
      dateFormat={DATE_FORMAT.INPUT_VALUE}
      displayTimeZone={getUserTimezone()}
      timezone={getUserTimezone()}
      minDate={typeof bounds.min?.value === 'string' ? bounds.min.value : undefined}
      maxDate={typeof bounds.max?.value === 'string' ? bounds.max.value : undefined}
      disabled={disabled}
      isRequired={required}
      errorMessages={error ? [''] : []}
      onChangeCallback={event => {
        const next = event.target.value;
        onChange(next ? (isIsoDate(next) ? formatDateForAPI(next) : next) : null);
      }}
      onBlurCallback={onBlur}
      sx={{ mb: 0 }}
    />
  );
};
